import { render, staticRenderFns } from "./InternsReport.vue?vue&type=template&id=12d90b9a&"
import script from "./InternsReport.vue?vue&type=script&lang=js&"
export * from "./InternsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports